import { api } from "../api/client";

export const confirmationReconciliationKey = () =>
  `confirmation-types-${window.crypto?.randomUUID?.() || `${Date.now()}-${Math.random()}`}`;

/** The single client-side entry point for the versioned confirmation selection. */
export function reconcileConfirmationTypes({ mandateId, version, bestaetigungsartIds, idempotencyKey }) {
  return api(`/mandates/${mandateId}/confirmation-types`, {
    method: "PUT",
    headers: { "If-Match": `"${version}"`, "Idempotency-Key": idempotencyKey },
    body: JSON.stringify({ bestaetigungsartIds }),
    retry: 1,
  });
}
